import { atom, createStore } from 'jotai';
import type { ReactFlowInstance } from 'reactflow';

export const reactFlowInstanceAtom = atom<ReactFlowInstance | null>(null);

export const reactFlowInstanceStore = createStore();

reactFlowInstanceStore.set(reactFlowInstanceAtom, null);
